module.exports = __webpack_public_path__ + "media/images/dermalogica-f00feb31d0f950839cdd52d8712e8cea.svg";